<script>
	import { onMount } from 'svelte';
	import { getText, jumpByAnchor } from '../../../../share/utils';

	let div;

	onMount(() => {
		jumpByAnchor(div);
	});
</script>

<div bind:this={div} id="unicontrol" class="page-middleclass-programming marginbox">
	<div class="flex structure">
		<div class="flex row structure-1">
			<div class="flex element">
				<div class="sketchfab-embed-wrapper">
					<iframe
							width="100%"
							height="100%"
							title="Van Conversion Layout"
							frameborder="0"
							border="0"
							allowfullscreen="allowfullscreen"
							mozallowfullscreen="true"
							allow="autoplay; fullscreen; xr-spatial-tracking"
							xr-spatial-tracking
							execution-while-out-of-viewport
							execution-while-not-rendered
							web-share
							src="https://sketchfab.com/models/26f32ec0508d4768accd674546f027cb/embed"/>
				</div>
			</div>
		</div>
		
		<div class="flex row structure-2">
			<div class="flex element">
				<img loading="lazy" alt="Kein Mittelmaß - UniControl - Design" src="./../img/15.Kein_Mittelmass/06.programming/Screen_overview.webp">
			</div>
			<div class="flex element">
				<div class="text">
					<h2 class="caption">{getText("15.06.01_h2")}</h2>
					<p class="caption">{getText("15.06.02_caption")}</p>
				</div>
			</div>
		</div>
	</div>
</div>

<style lang="scss">
	@import "../../../../style/mixins";
	@import "../../../../style/variables";
	
	img {
		width: 100%;
		margin: 0;
		padding: 0;
	}
	
	.img-single {
		margin: $spacing-mobile $spacing-mobile $media-gap $spacing-mobile;
	}
	
	h2,
	h2 {
		margin-bottom: $media-gap;
	}
	
	.page-middleclass-programming {
		.flex {
			display: flex;
			box-sizing: border-box;
		}
		
		.row {
			flex-flow: row wrap;
		}
		
		.col {
			flex-flow: column wrap;
		}
		
		.element {
			min-width: 100px;
		}
		
		.commercial {
			position: relative;
			width: 100%;
			height: 100%;
		}
		
		.content {
			flex: 1 100%;
		}
		
		.structure {
			flex-flow: row wrap;
		}
		
		.structure-1,
		.structure-2 {
			width: 100%;
			padding: 0;
			position: relative;
			
			> .element {
				width: 100%;
				margin-bottom: $media-gap;
				height: fit-content;
			}
		}
		
		.structure-2 {
			margin-bottom: 0;
			
			> .element:first-of-type {
				@include for-tablet-portrait-up {
					width: 70%;
					padding: $media-gap $media-gap*3 0 $media-gap*3;
				}
			}
			
			> .element:nth-of-type(2) {
				@include for-tablet-portrait-up {
					width: 30%;
				}
			}
		}
		
		.text {
			margin: 0;
		}
	}

	.sketchfab-embed-wrapper {
		width: 100%;
		height: 50vmin;

		iframe {
			border: 0;
		}
	}
</style>
